module.exports = __webpack_public_path__ + "v294910/img/icon_search.b88710a3.png";